"use client";
import React, { useEffect, useState } from "react";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { AMZ_VOUCHER, ICM_NAME_FULL, MAX_EARNING } from "@/app/utils/constants";
// import useMobile from "@/app/hooks/use-mobile";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useQuery } from "@tanstack/react-query";
import {
    getThirdPartyUserData,
    getUserEmail,
    postUserCheckpointsStatus,
} from "@/app/api/service/user";
// import { ThirdPartyData } from "@/app/interface/docvault";
import { UEListData } from "@/app/interface/homepage";
import { getUEListData } from "@/app/api/service/homepage";
import { ListingCategory } from "@/app/enums/unlisted";
import { getUserReferalDetail, getUserRewards } from "@/app/api/service/refer";
import RewardPreKYCSection from "@/app/refer/components/reward-pre-kyc";
import RewardPostKYCSection from "@/app/refer/components/reward-post-kyc";
// import ReferDrawer from "@/app/refer/components/refer-drawer";
import ReferComponent from "@/app/refer/components/refer-component";
import StartKycComp from "@/app/refer/components/start-kyc";
import ReferCalculator from "@/app/refer/components/refer-calculator";
import RewardPostInvestmentSection from "@/app/refer/components/reward-post-investment";
import ReferDrawer from "@/app/refer/components/refer-drawer";
import GoogleRecaptcha from "@/app/hooks/google-recaptcha";
import ICMWrapper from "@/app/components/icm-wrapper";
import ReferVoucher from "@/app/refer/components/refer-voucher";

const RECAPTCHA_CONFIG = {
    enabled: process.env.APP_RECAPTCHA_ENABLED === "true", // Control via env variable
    siteKey: process.env.APP_RECAPTCHA_KEY || "",
};

interface ReferProps {
    voucherAmt?: number;
    voucherText?: string;
    active?: string;
    setactive?: (value: string) => void; // Added setactive prop
    footerText?: string;
    title?: string;
    description?: string;
    isAuthenticated?: boolean;
    authLoading?: boolean;
    hideRewardsTab?: boolean;
    hideDashboardLink?: boolean;
    hideTransactionBenefit?: boolean;
}

interface UserReward {
    date: string;
    productType: string;
    product: string;
    productName: string;
    cashback: number;
    purchaseDiscount: number;
    units: number;
}

interface UserRewardsResponse {
    data: UserReward[];
}

// type UserStates = {
//     obUserApproved: boolean;
//     obUserNotInvested: boolean;
//     obOrderApproved: boolean;
//     obOrderRejected: boolean;
//     obPaymentDone: boolean;
//     obOrderAttempted: boolean;
// };

const ReferAndEarn: React.FC<ReferProps> = ({
    active,
    setactive,
    footerText,
    title,
    description,
    isAuthenticated,
    authLoading,
    voucherAmt,
    voucherText,
    hideRewardsTab,
    hideDashboardLink,
    hideTransactionBenefit,
}) => {
    const searchParams = useSearchParams();
    const [amtValue, setAmtValue] = useState<number>(100000);
    const [noOfFriends, setNoOfFriends] = useState<number>(5);
    const [activeTab, setActiveTab] = useState<string>();
    // const [userState, setuserState] = useState<UserStates | null>(null);
    const [userNotInvested, setUserNotInvested] = useState<boolean>(false);
    const [isKycDone, setisKycDone] = useState<boolean>(false);
    interface CheckPointsData {
        data?: string;
        [key: string]: string | undefined;
    }
    const [checkPointsData, setcheckPointsData] = useState<CheckPointsData | null>(null);
    // const [thirdPartyData, setthirdPartyData] = useState<ThirdPartyData>();
    // const [email, setEmail] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);
    const pathname = usePathname();
    const router = useRouter();
    const hasRewards = searchParams.has("rewards");

    useEffect(() => {
        setActiveTab(hasRewards ? "rewards" : "refer");
        if (setactive) {
            setactive(hasRewards ? "rewards" : "refer");
        }
    }, [hasRewards, pathname, router]);

    useEffect(() => {
        const hideRecaptchaBadge = () => {
            const badge = document.querySelector(".grecaptcha-badge") as HTMLElement;
            if (badge) {
                badge.style.visibility = "hidden";
            }
        };

        // Give it some time in case reCAPTCHA is not loaded instantly
        const interval = setInterval(() => {
            hideRecaptchaBadge();
        }, 0);

        // Clear interval once badge is found and hidden
        const timeout = setTimeout(() => {
            clearInterval(interval);
        }, 5000); // Stops trying after 5 seconds

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    const tabTitleData = {
        rewards: {
            title: isKycDone ? "You're ready to invest!" : "Complete your KYC!",
            description: `${isKycDone ? "Thank you for completing your KYC.<br/>" : ""}Buy Unlisted Shares and earn ₹200 cashback + 0.25% discount<br/> on 1st transaction`,
        },
        refer: {
            title: isKycDone ? "Referral Program" : "Earn up to ₹10,000 for every referral",
            description: isKycDone
                ? "Introducing our exciting referral Program - your opportunity to earn rewards while sharing the love with friends and family!"
                : "Invite your friends to " + ICM_NAME_FULL + " today!",
        },
    };

    // const {
    //     data: refActivityData,
    //     // isFetched: isRefActivityFetched,
    //     // isLoading: isRefActivityLoading,
    // } = useQuery({
    //     queryKey: ["refActivityData"],
    //     queryFn: () => getUserRefarralActivities(),
    // });

    const {
        data: userRefData,
        // isFetched: isUserRefDataFetched,
        // isLoading: isUserRefDataLoading,
    } = useQuery({
        queryKey: ["userRefData"],
        queryFn: () => getUserReferalDetail(),
    });

    // const {
    //     data: userRefarralsData,
    //     isFetched: isUserReferralsFetched,
    //     isLoading: isUserReferralsLoading,
    // } = useQuery({
    //     queryKey: ["userRefarralsData"],
    //     queryFn: () => getUserRefarrals(),
    // });

    const {
        data: userRewardsData,
        // isFetched: isUserRewardsFetched,
        isLoading: isUserRewardsLoading,
    } = useQuery<UserRewardsResponse>({
        queryKey: ["userRefarralsData"],
        queryFn: () => getUserRewards(),
    });

    const {
        data: userData,
        // isFetched: isUserFetched
    } = useQuery({
        queryKey: ["userData"],
        queryFn: getUserEmail,
    });

    const {
        data: tpdData,
        // isFetched: isTPDFetched
    } = useQuery({
        queryKey: ["tpdData"],
        queryFn: getThirdPartyUserData,
        enabled: !!userData,
        retry: 1,
    });

    const {
        data: ueData,
        isFetched: isUEFetched,
        isLoading: isUELoading,
    } = useQuery({
        queryKey: ["ueListData"],
        queryFn: () => getUEListData(),
    });

    const getFilteredData = (num: number) => {
        if (ueData && ueData.success && isUEFetched) {
            const filteredData = ueData?.data
                .filter(
                    (item: UEListData) =>
                        item?.ISIN?.includes("BASKET") === false &&
                        item?.company?.logoUrl?.length > 20 &&
                        item?.category === ListingCategory.LIVE,
                )
                .sort((a: UEListData, b: UEListData) => (a.order ?? 0) - (b.order ?? 0)); // Default to 0 if 'order' is undefined

            return filteredData.slice(0, num);
        }
    };

    useEffect(() => {
        if (tpdData) {
            setLoading(true); // Start loading
            postUserCheckpointsStatus(
                tpdData.data?.email,
                tpdData.data?.pan,
                [
                    "obUserAdminResponseDone",
                    "obUserApproved",
                    "obUserNotInvested",
                    "obOrderAttempted",
                    "obDocSigned",
                    "obPaymentDone",
                    "obOrderApproved",
                    "obOrderRejected",
                ],
                "obUserTxn",
                "orobonds",
                "unlistedEquities",
            )
                .then((response) => {
                    if (!response.success) {
                        console.error("Error posting user checkpoints status:", response.message);
                        setcheckPointsData({ data: "none" });
                    } else {
                        setcheckPointsData(response?.results);
                        setisKycDone(response?.results?.obUserApproved);
                        setUserNotInvested(response?.results?.obUserNotInvested);
                    }
                })
                .catch((error) => {
                    console.error(
                        "An error occurred while posting user checkpoints status:",
                        error,
                    );
                    setcheckPointsData({ data: "none" });
                })
                .finally(() => {
                    setLoading(false); // Stop loading
                });
        } else {
            setcheckPointsData({ data: "none" });
        }
    }, [tpdData]);

    // useEffect(() => {
    //     if (isTPDFetched && tpdData) {
    //         setthirdPartyData(tpdData?.data);
    //     }
    // }, [isTPDFetched, tpdData]);

    const handleFriendsChange = (increment: boolean) => {
        setNoOfFriends((prev) => Math.max(0, prev + (increment ? 1 : -1)));
    };

    const calculateReturns = React.useCallback(() => {
        if (amtValue <= 0 || noOfFriends <= 0) {
            return 0;
        }

        const transactionBenefit = 0.01 * amtValue;
        const totalBenefitPerUser = transactionBenefit + AMZ_VOUCHER;

        return Math.min(totalBenefitPerUser, MAX_EARNING) * noOfFriends;
    }, [amtValue, noOfFriends]);

    const ReferPostSection = () => {
        // if (loading) {
        //     return (
        //         <div className="mx-auto flex min-h-[423px] w-full items-center justify-center md:w-[1152px]">
        //             <LoadingIcon className="m-auto h-10 w-10 animate-spin sm:h-12 sm:w-12" />
        //         </div>
        //     );
        // }

        return isKycDone ? (
            RECAPTCHA_CONFIG.enabled ? (
                <GoogleRecaptcha sitekey={RECAPTCHA_CONFIG.siteKey}>
                    <ReferComponent
                        forWeb={true}
                        isKycDone={isKycDone}
                        username={tpdData?.name || ""}
                        referrerEmail={userData?.email || ""}
                        phone={userData?.phone}
                        userId={userData?.userId || ""}
                        recaptchaEnabled={RECAPTCHA_CONFIG.enabled}
                        refLink={
                            userRefData?.data?.bonds?.oneLink || userRefData?.data?.bonds?.link
                        }
                        isLoading={loading && checkPointsData === null}
                        voucherAmt={voucherAmt}
                        voucherText={voucherText}
                        hideDashboardLink={hideDashboardLink}
                        hideTransactionBenefit={hideTransactionBenefit}
                    />
                </GoogleRecaptcha>
            ) : (
                <ReferComponent
                    forWeb={true}
                    isKycDone={isKycDone}
                    username={tpdData?.name || ""}
                    referrerEmail={userData?.email || ""}
                    phone={userData?.phone}
                    userId={userData?.userId || ""}
                    refLink={userRefData?.data?.bonds?.oneLink || userRefData?.data?.bonds?.link}
                    isLoading={loading && checkPointsData === null}
                    voucherAmt={voucherAmt}
                    voucherText={voucherText}
                    hideDashboardLink={hideDashboardLink}
                    hideTransactionBenefit={hideTransactionBenefit}
                />
            )
        ) : (
            <StartKycComp
                isLoading={loading && checkPointsData === null}
                voucherAmt={voucherAmt}
                voucherText={voucherText}
                hideTransactionBenefit={hideTransactionBenefit}
                kycFlow={tpdData?.data?.kycFlow}
            />
        );
    };
    const referTabContent = () => {
        // Wait for all critical states to be resolved
        const isAuthenticatedAndLoading =
            isAuthenticated && (checkPointsData === null || checkPointsData?.data === null);

        if (authLoading || (isAuthenticated && loading) || isAuthenticatedAndLoading) {
            // Show nothing or a minimal full-loader here (if needed)
            return (
                <>
                    <ICMWrapper>
                        <div className="flex flex-col items-center justify-center gap-s14 py-s9 md:flex-row md:justify-between md:gap-s17 md:py-s17">
                            <ReferVoucher
                                isLoading={authLoading}
                                voucherAmt={voucherAmt}
                                voucherText={voucherText}
                                hideTransactionBenefit={hideTransactionBenefit}
                            />
                            <div className="flex flex-1 animate-pulse flex-col items-center justify-center rounded-3xl bg-white shadow-lg">
                                <div className="w-full border-b px-s13 py-s9 text-center text-lg font-semibold leading-[23px] text-neutral-900">
                                    <div className="mx-auto h-6 w-1/3 rounded bg-neutral-200" />
                                </div>
                                <div className="flex w-full flex-col flex-wrap sm:flex-row">
                                    <div className="flex flex-1 flex-col gap-s11 px-s13 py-s8 md:py-s14">
                                        <div className="flex flex-col items-center justify-center gap-s4">
                                            <div className="h-4 w-2/3 rounded bg-neutral-200" />
                                            <div className="flex items-center justify-center gap-s8">
                                                <div className="h-10 w-10 rounded-full bg-neutral-200" />
                                                <div className="h-8 w-12 rounded bg-neutral-200" />
                                                <div className="h-10 w-10 rounded-full bg-neutral-200" />
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-center justify-center gap-s5">
                                            <div className="h-4 w-2/3 rounded bg-neutral-200" />
                                            <div className="h-8 w-24 rounded bg-neutral-200" />
                                            <div className="h-2 w-full rounded bg-neutral-200" />
                                        </div>
                                    </div>
                                    <div className="my-s8 flex flex-1 items-center justify-center sm:mr-s6">
                                        <div className="flex h-full min-w-[85%] max-w-[85%] items-center justify-center rounded-xl bg-neutral-50 py-s6 md:min-w-[90%] md:max-w-[90%] md:px-s13 md:py-s9">
                                            <div className="flex w-full flex-col items-center gap-s4 p-s9">
                                                <div className="h-4 w-1/3 rounded bg-neutral-200" />
                                                <div className="h-10 w-1/2 rounded bg-neutral-200" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ICMWrapper>
                    <div className="flex w-full flex-col items-center justify-center gap-s9 px-s9">
                        <div className="h-12 w-full rounded bg-neutral-200" />
                        <div className="h-4 w-2/3 rounded bg-neutral-200" />
                    </div>
                </>
            );
        }

        if (isAuthenticated) {
            return ReferPostSection();
        }

        return (
            <ReferCalculator
                active={active}
                noOfFriends={noOfFriends}
                handleFriendsChange={handleFriendsChange}
                amtValue={amtValue}
                setAmtValue={setAmtValue}
                calculateReturns={calculateReturns}
                footerText={footerText}
                authLoading={false} // No longer loading
                voucherAmt={voucherAmt}
                voucherText={voucherText}
                hideTransactionBenefit={hideTransactionBenefit}
            />
        );
    };

    const rewardTabContent = () => {
        // if (authLoading || isUELoading || isUserRewardsLoading) {
        //     return (
        //         <div className="mx-auto flex min-h-[423px] w-[1152px] items-center justify-center">
        //             <LoadingIcon className="m-auto h-10 w-10 animate-spin sm:h-12 sm:w-12" />
        //         </div>
        //     );
        // }

        if (!isKycDone) {
            return (
                <RewardPreKYCSection
                    isUELoading={isUELoading}
                    data={getFilteredData(4)}
                    isKycDone={isKycDone}
                    referrerEmail={userData?.email || ""}
                    phone={userData?.phone}
                    userId={userData?.userId || ""}
                    title={tabTitleData[activeTab as keyof typeof tabTitleData]?.title}
                    description={tabTitleData[activeTab as keyof typeof tabTitleData]?.description}
                    isLoading={
                        authLoading ||
                        isUELoading ||
                        isUserRewardsLoading ||
                        checkPointsData === null
                    }
                    kycFlow={tpdData?.data?.kycFlow}
                />
            );
        }

        if (isKycDone && !userNotInvested && userRewardsData?.data?.length) {
            return (
                <RewardPostInvestmentSection
                    isUELoading={isUELoading}
                    data={getFilteredData(4)}
                    referrerEmail={userData?.email || ""}
                    phone={userData?.phone}
                    userId={userData?.userId || ""}
                    userRewardsData={userRewardsData}
                    isUserRewardsLoading={isUserRewardsLoading}
                    isLoading={
                        authLoading ||
                        isUELoading ||
                        isUserRewardsLoading ||
                        checkPointsData === null
                    }
                />
            );
        } else {
            return (
                <RewardPostKYCSection
                    isUELoading={isUELoading}
                    data={getFilteredData(4)}
                    referrerEmail={userData?.email || ""}
                    userId={userData?.userId || ""}
                    phone={userData?.phone}
                    title={tabTitleData[activeTab as keyof typeof tabTitleData].title}
                    description={tabTitleData[activeTab as keyof typeof tabTitleData].description}
                    isLoading={
                        authLoading ||
                        isUELoading ||
                        isUserRewardsLoading ||
                        checkPointsData === null
                    }
                />
            );
        }
    };

    return (
        <div
            className={`pb-14 pt-s11 md:px-s9 md:pb-s20 ${activeTab === "refer" ? "bg-transparent md:bg-neutral-100" : ""}`}
        >
            <Tabs
                defaultValue={hasRewards ? "rewards" : "refer"}
                className="w-full md:mx-auto md:!w-[1152px]"
                onValueChange={(value) => {
                    if (setactive) {
                        setactive(value);
                    }
                    setActiveTab(value);
                    if (hasRewards) {
                        router.replace(pathname, { scroll: false });
                    }
                }}
            >
                {isAuthenticated && !hideRewardsTab ? (
                    <TabsList className="flex w-full justify-start bg-transparent">
                        <TabsTrigger
                            className="inline-flex h-11 !w-[236px] items-center justify-center whitespace-nowrap border-b border-b-neutralOpacityDark-10 py-s7 text-sm font-medium leading-[22.4px] tracking-[0.14px] text-neutral-300 transition-all disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-b-2 data-[state=active]:border-b-brand-primary-500 data-[state=active]:bg-transparent data-[state=active]:text-brand-primary-500 md:w-[236px]"
                            value="refer"
                        >
                            Refer
                        </TabsTrigger>
                        <TabsTrigger
                            className="inline-flex h-11 !w-[236px] items-center justify-center whitespace-nowrap border-b border-b-neutralOpacityDark-10 py-s7 text-sm font-medium leading-[22.4px] tracking-[0.14px] text-neutral-300 transition-all disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-b-2 data-[state=active]:border-b-brand-primary-500 data-[state=active]:bg-transparent data-[state=active]:text-brand-primary-500 md:w-[236px]"
                            value="rewards"
                        >
                            Rewards
                        </TabsTrigger>
                    </TabsList>
                ) : null}
                <>
                    {(active === "unlisted-shares" || activeTab === "refer") &&
                        (authLoading ||
                        (isAuthenticated && loading) ||
                        (isAuthenticated &&
                            (checkPointsData === null || checkPointsData?.data === "none")) ? (
                            // Skeleton loader for header/title/description
                            <div className="mx-6 my-8 flex animate-pulse flex-col items-center justify-center gap-5 text-center md:mx-0 md:my-14 md:mb-0 md:mt-6">
                                <div className="mx-auto mb-3 h-12 w-2/3 max-w-[828px] rounded bg-neutral-200 md:h-16" />
                                <div className="mx-auto h-6 w-1/2 rounded bg-neutral-200 md:h-8" />
                            </div>
                        ) : active === "unlisted-shares" ? (
                            <div className="mx-s9 mb-0 mt-6 flex flex-col items-center justify-center text-center md:my-14">
                                <h2
                                    className="mx-auto mb-3 max-w-[828px] text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] text-neutral-900 md:mb-0 md:text-7xl md:leading-[67px] md:tracking-[-0.56px]"
                                    dangerouslySetInnerHTML={{ __html: title as string }}
                                />
                                <div
                                    className="mx-auto text-md leading-[25.6px] tracking-[-0.2px] text-neutral-500 md:max-w-[872px] md:text-xl md:leading-[32px]"
                                    dangerouslySetInnerHTML={{ __html: description as string }}
                                />
                            </div>
                        ) : activeTab === "refer" ? (
                            <div className="mx-6 my-8 flex flex-col items-center justify-center gap-5 text-center md:mx-0 md:my-14 md:mb-0 md:mt-6">
                                <div
                                    className="mx-auto mb-3 max-w-[828px] text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] text-neutral-900 md:mb-0 md:text-7xl md:leading-[67px] md:tracking-[-0.56px]"
                                    dangerouslySetInnerHTML={{
                                        __html: tabTitleData[activeTab as keyof typeof tabTitleData]
                                            .title,
                                    }}
                                />
                                <div
                                    className="mx-auto text-md leading-[25.6px] tracking-[-0.2px] text-neutral-500 md:max-w-[872px] md:text-xl md:leading-[32px]"
                                    dangerouslySetInnerHTML={{
                                        __html: tabTitleData[activeTab as keyof typeof tabTitleData]
                                            .description,
                                    }}
                                />
                            </div>
                        ) : null)}
                </>

                <TabsContent value="refer">{referTabContent()}</TabsContent>
                <TabsContent value="rewards">{rewardTabContent()}</TabsContent>
            </Tabs>
            {isAuthenticated ? (
                <ReferDrawer
                    isAuthenticated={isAuthenticated}
                    isKycDone={isKycDone}
                    userNotInvested={userNotInvested}
                    isLoading={authLoading}
                    loading={loading}
                    refLink={userRefData?.data?.bonds?.oneLink || userRefData?.data?.bonds?.link}
                />
            ) : null}
        </div>
    );
};

export default ReferAndEarn;
